/**
 * Extract file identification from API response
 * @param {Object} response - API response object
 * @param {File} file - Original file object for fallback
 * @returns {string} - Identification for the uploaded file
 */
export const extractFileIdentification = (response, file) => {
	
	return response?.data[0]?.id || "";
};
